import { sendGet } from './axios';

export const getEnvironment = (payload) => sendGet(`/get-env`, payload);

export const getEnvironmentUI = () => sendGet(`/get-env-ui`);

export const getAllResource = (payload) => sendGet(`/all-resource`, payload);

export const getAllResourceProfile = (payload) => sendGet(`/resource-profile`, payload);

export const getProfileMeta = (payload) => sendGet(`/profile-meta`, payload);

export const getProfileMetaNoLogin = (payload) => sendGet(`/profile-meta-trial`, payload);

export const getAllStateOption = (payload) => sendGet(`/all-state/options`, payload);

export const getAllArea = (stateId) => sendGet(`/all-area/${stateId}`);

export const getCampaign = () => sendGet(`/campaigns`, { typeApp: 0 });

export const getPopup = () => sendGet(`/popups`, { typeApp: 0 });

export const getEnvInfo = (params) => sendGet('/cms/env_info', params);

export const getEnvSysCms = (params) => sendGet('/cms/env_sys_cms/all', params);
